export default {
	messageTemplates: {
		'content|_defaults|accessibleIsLoadingText': 'Processing, please wait a moment',
		'content|_defaults|continueLabel': 'Continue',
		'content|_defaults|and': 'and',
		'content|_defaults|or': 'or',

		'content|login:email|facebookLoginButtonLabel': 'Continue with Facebook',
		'content|login:email|facebookAssuranceMessage': 'Donate faster. We\'ll never post on your behalf',
		'content|login:email|emailFieldLabel': 'Email',
		'content|login:email|defaultContinueButtonLabel': 'Continue',
		'content|login:email|accessibleEmailLoginText': 'log in with your email address',

		'content|login:password|defaultHeading1': 'Welcome back',
		'content|login:password|passwordFieldLabel': 'Password',
		'content|login:password|defaultContinueButtonLabel': 'Login',
		'content|login:password|passwordFieldHintLabelShow': 'Show',
		'content|login:password|passwordFieldHintLabelHide': 'Hide',
		'content|login:password|editEmailAddressButtonLabel': 'Edit',
		'content|login:password|correctEmailAddressMessage': 'Not you?',
		'content|login:password|forgotPasswordMessage': 'Forgot your password?',
		'content|login:password|loginWithFacebookMessage': 'Log in with Facebook',
		'content|login:password|resetPasswordMessage': 'Reset your password',

		'content|login:register|firstNameFieldLabel': 'First name',
		'content|login:register|lastNameFieldLabel': 'Last name',
		'content|login:register|passwordFieldLabel': 'Password',
		'content|login:register|defaultContinueButtonLabel': 'Continue',
		'content|login:register|loginAlertLinkText': 'Log In',
		'content|login:register|TsAndCs-1': 'By clicking continue you agree to JustGiving’s',
		'content|login:register|termsOfServiceLinkText': 'Terms of Service',
		'content|login:register|PrivacyPolicyLinkText': 'Privacy Policy',
	},
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/i18n/lang/en/en_content.js